import { ITheme } from "../../utils/theme";

export const descriptionStyle = {
  mt: 3,
  mb: 2,
  textAlign: { xs: 'center' }
};

export const subHeaderStyle = {
  mb: 3,
  textAlign: { xs: 'center' }
};


export const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const disclaimerContainerStyle = {
  position: "relative",
  width: "100%",
  margin: "auto",
}

export const disclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "100px",
  width: "100%"
}

export const disclaimerStyle = {
  display: "flex",
  mt: 1,
  color: (theme: ITheme) => theme.palette.red[650],
  cursor: "pointer",
  "& p": {
    fontWeight: "bold",
  }
}